import React from "react";
import { Select } from "antd";
import languageData from "../../containers/Topbar/languageData";

const { Option } = Select;

const normalize = (locale) => {
  const raw = typeof locale === "string" ? locale : locale?.locale;
  return typeof raw === "string" ? raw.toLowerCase() : "";
};

/**
 * Verilen dil kodunun languageData karsiligini dondurur.
 * Bulamazsa null doner — cagiran taraf kendi varsayilanini secebilir.
 */
export const matchLanguage = (locale) => {
  const normalized = normalize(locale);
  if (!normalized) return null;
  return (
    languageData.find((item) => item.locale === normalized) ||
    languageData.find((item) => item.locale === normalized.split("-")[0]) ||
    null
  );
};

/** Eski davranis: eslesme yoksa ilk dile (Turkce) duser. */
export const findLanguageByLocale = (locale) => matchLanguage(locale) || languageData[0];

const LanguageSelector = ({ value, onChange, className = "", dropdownClassName, style = {} }) => {
  const selected = matchLanguage(value) || languageData[0];

  return (
    <Select
      className={className}
      /* Acilir liste portal ile body'ye cikiyor; cagiran taraf temasini
         gecirebilsin diye disari aciyoruz. */
      dropdownClassName={dropdownClassName}
      style={{ width: 180, minWidth: 120, ...style }}
      value={selected.locale}
      onChange={(locale) => onChange?.(locale)}
      dropdownMatchSelectWidth={false}
      showSearch
      optionFilterProp="title"
    >
      {languageData.map((language) => (
        <Option key={language.locale} value={language.locale} title={language.name}>
          <span style={{ marginRight: 8 }}>{language.flag || "🌐"}</span>
          {language.name}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
